"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewOnlyBanner = void 0;
var react_1 = __importDefault(require("react"));
var ViewOnlyBanner = function () {
    return (react_1.default.createElement("section", { className: "project-info-banner project-info-banner--center" },
        react_1.default.createElement("div", { className: "title" }, "You are in view only mode \u2014 contact the owner to edit this Qwilr Page")));
};
exports.ViewOnlyBanner = ViewOnlyBanner;
